import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, type TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';

interface Props {}

const BackToDaLinkListItem: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <ListItemLink
      label={t('sidebar.links.backToDa')}
      href={Url.browseHomeLink()}
      biData={BiData<TopNavClickBiEvent>({
        evid: 700,
        link_name: t('sidebar.links.backToDa'),
        link_url: Url.browseHomeLink(),
      })}
    />
  );
};

BackToDaLinkListItem.displayName = 'BackToDaLinkListItem';

export default BackToDaLinkListItem;
